import React from 'react';

import Section from '../../../HOC/Section';


const contact = () => {
  return (
    <Section id='contact'>
      <div className='container pt-2 pb-5'>
        <div className='section-header pt-5 pb-5 text-center'>
          <h3 className='section-title'>
            <span>Contatos </span>
          </h3>
          <h6 className='section-subtitle mr-auto ml-auto'>
            Endereço : Rua Presidente Carlos Cavalcanti, 121 - Rio Branco do Sul - PR
            <br />
            Telefone : +55 (41) 92004-2554
            <br /><br />
            <a href="https://api.whatsapp.com/send?phone=5541920042554" target="_blank" rel="noopener noreferrer">
                <button className='btn btn-success rounded-0'>Fale conosco através de nosso WhatsApp</button>
            </a>
          </h6>
        </div>
        {/* <div className='section-content'>
          <div className='row'>
            <div className='col-md-9 col-lg-7 mr-auto ml-auto'>
              <form>
                <div className='form-group'>
                  <input
                    type='text'
                    className='form-control rounded-0'
                    aria-describedby='emailHelp'
                    placeholder='Enter Name...'
                  />
                </div>
                <div className='form-group'>
                  <input
                    type='email'
                    className='form-control rounded-0'
                    aria-describedby='emailHelp'
                    placeholder='Enter email...'
                  />
                </div>
                <div className='form-group'>
                  <textarea
                    className='form-control rounded-0'
                    rows='5'
                    placeholder='Enter Message...'
                  />
                </div>
                <div className='form-group text-center'>
                  <button className='btn btn-block btn-primary rounded-0 mr-auto ml-auto'>
                    Send
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div> */}
      </div>
    </Section>
  );
};

export default contact;
